
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.489 7.591a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5zm0-4a1.5 1.5 0 101.5 1.5 1.5 1.5 0 00-1.5-1.5zM21.5 7.5A2.5 2.5 0 1124 5a2.5 2.5 0 01-2.5 2.5zm0-4A1.5 1.5 0 1023 5a1.5 1.5 0 00-1.5-1.5zM9 11.5a2.5 2.5 0 010-5A2.5 2.5 0 0111.5 9 2.5 2.5 0 019 11.5zm0-4a1.5 1.5 0 00-1.057 2.562A1.313 1.313 0 009 10.5 1.5 1.5 0 0010.5 9 1.5 1.5 0 009 7.5zm-4 14A2.5 2.5 0 117.5 19 2.5 2.5 0 015 21.5zm0-4A1.5 1.5 0 106.5 19 1.5 1.5 0 005 17.5zm14 4a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5zm0-4a1.5 1.5 0 101.5 1.5 1.5 1.5 0 00-1.5-1.5z"}}),_c('path',{attrs:{"d":"M7.221 8.5a.491.491 0 01-.249-.067l-3-1.732a.5.5 0 01.5-.866l3 1.732a.5.5 0 01-.251.933zm12.232-2.98h-14.8a.5.5 0 110-1h14.8a.5.5 0 010 1z"}}),_c('path',{attrs:{"d":"M10.9 8.866a.5.5 0 01-.133-.982l8.824-2.451a.5.5 0 01.268.964l-8.828 2.451a.522.522 0 01-.131.018zm-5.114 8.795a.522.522 0 01-.164-.027.5.5 0 01-.309-.634l2.223-6.424a.5.5 0 11.945.328l-2.222 6.42a.5.5 0 01-.473.337z"}}),_c('path',{attrs:{"d":"M6.431 18.1a.5.5 0 01-.315-.889L19.872 6.123a.5.5 0 01.628.777L6.744 17.992a.494.494 0 01-.313.108z"}}),_c('path',{attrs:{"d":"M17.434 18.256a.5.5 0 01-.352-.145l-7.217-7.17a.5.5 0 01.706-.709l7.216 7.17a.5.5 0 01-.353.854zm1.507-.756a.485.485 0 01-.1-.01.5.5 0 01-.39-.59L20.51 6.837a.5.5 0 01.98.2L19.43 17.1a.5.5 0 01-.489.4zM17 19.5H7a.5.5 0 010-1h10a.5.5 0 010 1z"}})])
          )
        }
      }
    